import React from "react";
import EndlessLearning from "../Component/EndlessLearning";
import Company from "../Component/Company";
import WorkPage from "../Component/WorkPage";
import Course from "../Component/Course";
import InternshipExperience from "../Component/InternshipExperience";
import LearnPage from "../Component/LearnPage";
import PricingPage from "../Component/Pricing";
import SuccessPage from "../Component/SuccessPage";
import Certified from "../Component/Certified";


export default function Main_Home_Page() {
  return (
    <>
      <EndlessLearning />
      <Company />
      <Certified />
      <WorkPage />
      <Course />
      
      <InternshipExperience />
      {/* <LearnPage  /> */}
      {/* <PricingPage /> */}
      <SuccessPage />
    </>
  );
}
